module.exports = __webpack_public_path__ + "static/media/freeeats.f48db45f.png";